/* Sunkissed custom (15a + 15b): menu and cart drawers open BELOW a live header on mobile,
   header icons swap between them, "View bag" bar in the menu, "← Menu" in the cart. */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 749px)');
  function q(s, r) { return (r || document).querySelector(s); }
  function menuEl() { return q('header-drawer.drawer--header'); }
  function cartEl() { return q('cart-drawer.drawer--cart'); }
  function isOpen(el) { return !!el && el.classList.contains('is-open'); }
  function headerBottom() {
    // measure the visible mobile bar (the header wrapper may be transformed/hidden while scrolled)
    // use the visible mobile bar only; ignore the (hidden) desktop bar and any announcement that has scrolled away
    // the mobile bar itself (logo row), measured on screen; announcement is hidden while a drawer is open
    // measure the logo row itself (its bottom edge on screen), never the wrapper
    var hd = q('.header__mobile__middle') || q('.header__mobile__logo') || q('.header__mobile');
    if (!hd) return 84;
    var r = hd.getBoundingClientRect();
    var wrap = q('.header__wrapper') || hd;
    var wb = Math.round(wrap.getBoundingClientRect().bottom);
    var b = (wb > 20 && wb < 160) ? wb : Math.round(r.bottom);
    if (b <= 20 || b > 160) b = 84;
    return b;
  }
  var lastOpened = null;
  var swapTimer = null;
  function markSwap() {
    document.body.classList.add('sk-swap');
    clearTimeout(swapTimer);
    swapTimer = setTimeout(function () { document.body.classList.remove('sk-swap'); sync(); }, 620);
  }
  function fadeOut(el) {
    if (!el) return;
    el.classList.add('sk-fade-out');
    setTimeout(function () { el.classList.remove('sk-fade-out'); }, 460);
  }
  function hardCloseCart() {
    var c = cartEl(); if (!c) return;
    fadeOut(c);
    c.classList.remove('is-open', 'is-closing', 'sk-settled');
    if ('isAnimating' in c) c.isAnimating = false;
    document.body.classList.remove('sk-cart-open');
  }
  function forceCloseMenu() {
    var m = menuEl(); if (!m) return;
    if (document.body.classList.contains('sk-swap')) fadeOut(m);
    // hard close: no animation, no waiting on the theme's animation lock
    m.classList.remove('is-open', 'is-closing', 'drawer--animated', 'sk-settled');
    m.isAnimating = false;
    var hb = hamburger(); if (hb) hb.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('sk-menu-open');
  }
  function sync() {
    var m = isOpen(menuEl()), c = isOpen(cartEl());
    // only one drawer at a time: whichever opened last wins
    if (m && c) {
      if (lastOpened === 'menu') { closeCart(); c = false; }
      else { forceCloseMenu(); m = false; }
    }
    var b = document.body;
    b.classList.toggle('sk-menu-open', m);
    b.classList.toggle('sk-cart-open', c);
    var swapping = b.classList.contains('sk-swap');
    b.classList.toggle('sk-drawer-open', mq.matches && (m || c || swapping));
    if (mq.matches && (m || c)) document.documentElement.style.setProperty('--sk-drawer-top', headerBottom() + 'px');
  }
  function watch(el, name) {
    if (!el) return;
    var was = isOpen(el);
    new MutationObserver(function () {
      var now = isOpen(el);
      if (now && !was) lastOpened = name;
      if (!now && el.classList.contains('sk-settled') && !document.body.classList.contains('sk-swap')) el.classList.remove('sk-settled');
      was = now;
      sync();
    }).observe(el, { attributes: true, attributeFilter: ['class'] });
  }
  function hamburger() { return q('.header__mobile__hamburger'); }
  function cartToggle() { return q('.header__mobile [data-cart-toggle]') || q('[data-cart-toggle]'); }
  function closeCart() {
    var c = cartEl(); if (!isOpen(c)) return false;
    var x = q('[data-cart-drawer-close]', c) || q('.drawer__close', c);
    if (x) x.click(); else c.classList.remove('is-open');
    return true;
  }
  var bypass = false;
  function openMenu() {
    var wasCart = isOpen(cartEl());
    if (wasCart) { markSwap(); hardCloseCart(); var mm = menuEl(); if (mm) mm.classList.add('sk-settled'); }
    lastOpened = 'menu';
    var hb = hamburger();
    var m = menuEl(); if (m) m.isAnimating = false;   // never let a stale animation lock swallow the tap
    if (!m || isOpen(m)) return;
    if (wasCart) {
      // swap from the cart: open the menu directly. The page is already scroll-locked by the cart, so skip the theme's
      // open routine (scroll-lock + focus trap), which is what made this direction hitch.
      m.classList.add('is-open', 'drawer--animated');
      if (hb) hb.setAttribute('aria-expanded', 'true');
      m.triggerButton = hb || null;
      sync();
      return;
    }
    if (hb) { bypass = true; hb.click(); bypass = false; }
  }
  function openCart() {
    lastOpened = 'cart';
    var hadMenu = isOpen(menuEl());
    if (hadMenu) { markSwap(); forceCloseMenu(); var cc = cartEl(); if (cc) cc.classList.add('sk-settled'); }
    var t = cartToggle();
    var c = cartEl(); if (c && 'isAnimating' in c) c.isAnimating = false;
    if (hadMenu && c) {
      // swap from the menu: open the cart directly (page is already scroll-locked by the menu), same as bag -> menu
      c.classList.add('is-open');
      document.dispatchEvent(new CustomEvent('theme:cart-drawer:open', { bubbles: true }));
      sync();
      return;
    }
    bypass = true; if (t) t.click(); else window.location.href = '/cart'; bypass = false;
  }
  document.addEventListener('click', function (e) {
    if (!mq.matches) return;
    var oc = e.target.closest && e.target.closest('[data-sk-open-cart]');
    if (oc) { e.preventDefault(); openCart(); return; }
    var om = e.target.closest && e.target.closest('[data-sk-open-menu]');
    if (om) { e.preventDefault(); openMenu(); return; }
    // hamburger tapped while the cart is open: swap to the menu
    if (bypass) return;
    var bagIcon = e.target.closest && e.target.closest('.header__mobile [data-cart-toggle]');
    if (bagIcon && isOpen(menuEl())) { e.preventDefault(); e.stopPropagation(); openCart(); return; }
    // bag icon tapped while the bag is already open: close it (mirrors the hamburger)
    if (bagIcon && isOpen(cartEl())) { e.preventDefault(); e.stopPropagation(); closeCart(); return; }
    var hb = e.target.closest && e.target.closest('.header__mobile__hamburger');
    if (hb && isOpen(cartEl())) { e.preventDefault(); e.stopPropagation(); openMenu(); }
  }, true);
  // keep the bag bar in the menu up to date after AJAX adds/removes
  function refreshBag() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-sk-bag-count]').forEach(function (el) { el.textContent = cart.item_count; });
      var total = (cart.total_price / 100).toFixed(2).replace(/\.00$/, '');
      document.querySelectorAll('[data-sk-bag-total]').forEach(function (el) { el.textContent = '$' + total; });
      document.querySelectorAll('.sk-bagbar-wrap').forEach(function (el) { el.classList.toggle('is-empty', cart.item_count === 0); });
      document.querySelectorAll('[data-sk-bag-thumbs2]').forEach(function (el) {
        el.innerHTML = cart.items.slice(0, 2).filter(function (i) { return i.image; }).map(function (i) {
          var src = i.image.indexOf('?') > -1 ? i.image + '&width=100' : i.image + '?width=100';
          return '<img src="' + src + '" alt="">';
        }).join('');
      });
    }).catch(function () {});
  }
  ['theme:cart:change', 'theme:cart:refresh', 'theme:cart:update', 'theme:product:added'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(refreshBag, 400); });
  });
  window.addEventListener('scroll', function () { if (document.body.classList.contains('sk-drawer-open')) sync(); }, { passive: true });
  function prewarm() {
    var m = menuEl(); if (!m) return;
    m.querySelectorAll('img').forEach(function (img) { img.loading = 'eager'; if (img.decode) img.decode().catch(function () {}); });
  }
  function init() {
    if ('requestIdleCallback' in window) requestIdleCallback(prewarm, { timeout: 2000 }); else setTimeout(prewarm, 1200);
    document.documentElement.style.setProperty('--sk-drawer-top', headerBottom() + 'px');
    watch(menuEl(), 'menu'); watch(cartEl(), 'cart'); sync();
  }
  // keep the offset right before any drawer opens (header height changes as the announcement scrolls away)
  document.addEventListener('touchstart', function (e) {
    if (!mq.matches) return;
    if (e.target.closest && e.target.closest('[data-cart-toggle], .header__mobile__hamburger, [data-sk-open-cart], [data-sk-open-menu]')) {
      document.documentElement.style.setProperty('--sk-drawer-top', headerBottom() + 'px');
    }
  }, { passive: true, capture: true });
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
